import { Link, Outlet, useParams } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import t from "@/lang/lang";
import { Card, CardContent } from "@/shared/components/ui/card";
import { useQpmMonitorGetQuery } from "@/services/backend/qpm/monitors/api/monitor-api";
import { MonitorTypeUtil } from "@/services/backend/qpm/lib/monitor-type-util";
import { monitorTypeToQuery } from "@/routes/base-data/processes/qpm/catalog/monitor-type-query";

export function MonitorsRoute() {
  const { monitorId } = useParams();
  const basePath = "/base-data/processes/qpm";

  const { data: monitor } = useQpmMonitorGetQuery(
    { id: monitorId! },
    { skip: !monitorId },
  );

  return (
    <Card>
      {monitorId && monitor && (
        <CardContent>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to={`${basePath}/monitors`}>
                    {t("Monitorübersicht")}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link
                    to={`${basePath}/monitors?type=${monitorTypeToQuery(
                      monitor.type,
                    )}`}
                  >
                    {MonitorTypeUtil.toLongString(monitor.type)}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>{monitor.name || t("Monitor")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </CardContent>
      )}

      <CardContent>
        <Outlet />
      </CardContent>
    </Card>
  );
}
